export const STATUS_OPTIONS = [
  { value: 'new', label: 'New', className: 'status-new' },
  { value: 'contacted', label: 'Contacted', className: 'status-contacted' },
  { value: 'quoted', label: 'Quoted', className: 'status-quoted' },
  { value: 'follow-up', label: 'Follow-up', className: 'status-follow-up' },
  { value: 'negotiating', label: 'Negotiating', className: 'status-negotiating' },
  { value: 'won', label: 'Won', className: 'status-won' },
  { value: 'lost', label: 'Lost', className: 'status-lost' },
];

export const getLeadStatus = (value) => STATUS_OPTIONS.find((status) => status.value === value)
  || { value, label: value === 'interested' ? 'Interested' : value || 'Not set', className: 'bg-gray-100 text-gray-700' };
